// salesArticleMenu.js

import '../styles/salesArticleMenu.css';
import "../styles/loadingModal.css";

import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

import useAuth from "../components/useAuth";
import FilterField from "../components/salesFilters";
import GenericModal from "../components/filtersModal";
import LoadingModal from "../components/loadingModal";

import homeIcon from "../assets/home-icon.png";

import * as XLSX from "xlsx";

import {
  PieChart,
  Pie,
  Cell,
  Tooltip as ReTooltip,
  ResponsiveContainer,
  Legend,
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis
} from "recharts";

export default function SalesArticleMenu() {

  const { userName, clientName } = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Galileo Analytics - Ventas por Artículo";
  }, []);

  // =========================================================
  // MODAL
  // =========================================================

  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [modalData, setModalData] = useState([]);

  const openFilterModal = async (type) => {

    setModalType(type);
    setModalTitle("Seleccionar " + type);
    setModalOpen(true);

    try {

      const response = await fetch(
        "api/salesArticleFilters.php?filter=" + type,
        {
          method: "GET",
          credentials: "include"
        }
      );

      if (response.status === 401) {

        localStorage.clear();

        alert("Sesión expirada");

        navigate("/");

        return;
      }

      const text = await response.text();

      try {

        const data = JSON.parse(text);

        setModalData(data);

      } catch (jsonError) {

        console.error("JSON parse error:", text);

        setModalData([]);
      }

    } catch (error) {

      console.error("Error cargando datos:", error);

      setModalData([]);
    }
  };

  const openPeriodModal = () => {

    setModalType("period");

    setModalTitle("Período:");

    setModalData([
      { label: "Hoy", value: "hoy" },
      { label: "Esta Semana", value: "semana" },
      { label: "Este Mes", value: "mes" }
    ]);

    setModalOpen(true);
  };

  const closeFilterModal = () => {

    setModalOpen(false);

    setModalType("");

    setModalTitle("");
  };

  // =========================================================
  // FILTROS
  // =========================================================

  const filters = [

    {
      label: "Período",
      type: "select",
      name: "period",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openPeriodModal()
    },

    { label: "Desde", type: "date", name: "fechaDesde" },

    { label: "Hasta", type: "date", name: "fechaHasta" },

  /*  {
      label: "Cliente",
      type: "text",
      name: "cliente",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("cliente")
    },*/

    {
      label: "Sucursal",
      type: "text",
      name: "sucursal",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("sucursal"),
      placeholder: "Central por Defecto"
    },

    {
      label: "Vendedor",
      type: "text",
      name: "vendedor",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("vendedor")
    },

  /*  {
      label: "Comprobante",
      type: "text",
      name: "comprobante",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("comprobante")
    },*/

    {
      label: "Rubro-Subrubro",
      type: "text",
      name: "rubro",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("rubro")
    },

    {
      label: "Artículo",
      type: "text",
      name: "articulo",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("articulo")
    },

   /* {
      label: "Proveedor",
      type: "text",
      name: "proveedor",
      readOnly: true,
      withButton: true,
      onButtonClick: () => openFilterModal("proveedor")
    }*/
  ];

  const [filtersState, setFiltersState] = useState({

    fechaDesde: "",
    fechaHasta: "",

   /* cliente: "",
    cCliente: "",*/

    sucursal: "",
    cSucursal: "",

    vendedor: "",
    cVendedor: "",

  /*  comprobante: "",
    cComprobante: "",*/

    period: "Hoy",
    periodValue: "hoy",

    rubro: "",
    cRubro: "",
    cSubRubro: "",

    articulo: "",
    cArticulo: "",

   /* proveedor: "",
    cProveedor: ""*/
  });

  const [filterMode, setFilterMode] = useState("rubro");  
  // =========================================================
  // HANDLE SELECT
  // =========================================================

  const handleSelect = (item) => {

    if (!modalType) return;

    const pick = (obj, ...keys) => {

      for (const k of keys) {

        if (obj == null) continue;

        if (Object.prototype.hasOwnProperty.call(obj, k)) {
          return obj[k];
        }
      }

      return undefined;
    };

    switch (modalType) {

     /* case "cliente": {

        const text =
          pick(item, "cliente", "CLIENTE", "nombre", "NOMBRE");

        const val =
          pick(item, "cCliente", "CCLIENTE", "id", "ID");

        setFiltersState(prev => ({
          ...prev,
          cliente: text ?? "",
          cCliente: val ?? ""
        }));

        break;
      }*/

      case "sucursal": {

        const text =
          pick(item, "sucursal", "SUCURSAL", "nombre", "NOMBRE");

        const val =
          pick(item, "cSucursal", "CSUCURSAL", "id", "ID");

        setFiltersState(prev => ({
          ...prev,
          sucursal: text ?? "",
          cSucursal: val ?? ""
        }));

        break;
      }

      case "vendedor": {

        const text =
          pick(item, "usuario", "USUARIO", "nombre", "NOMBRE");

        const val =
          pick(item, "cUsuario", "CUSUARIO", "id", "ID");

        setFiltersState(prev => ({
          ...prev,
          vendedor: text ?? "",
          cVendedor: val ?? ""
        }));

        break;
      }

    /*  case "comprobante": {

        const text =
          pick(item, "comprobante", "COMPROBANTE", "nombre", "NOMBRE");

        const val =
          pick(item, "cComprobante", "CCOMPROBANTE", "id", "ID");

        setFiltersState(prev => ({
          ...prev,
          comprobante: text ?? "",
          cComprobante: val ?? ""
        }));

        break;
      }*/

      case "period": {

        setFiltersState(prev => ({
          ...prev,
          period: item.label,
          periodValue: item.value,
          fechaDesde: "",
          fechaHasta: ""
        }));

        break;
      }

      case "rubro": {

        const rubroName =
          pick(item, "rubro", "RUBRO");

        const subrubroName =
          pick(item, "subrubro", "SUBRUBRO");

        const cRubro =
          pick(item, "cRubro", "CRUBRO");

        const cSubRubro =
          pick(item, "cSubrubro", "CSUBRUBRO", "id");

        setFiltersState(prev => ({
          ...prev,
          rubro: `${rubroName} - ${subrubroName}`,
          cRubro: cRubro ?? "",
          cSubRubro: cSubRubro ?? ""
        }));

        break;
      }

      case "articulo": {

        const text =
          pick(item, "articulo", "ARTICULO", "nombre", "NOMBRE");

        const val =
          pick(item, "cArticulo", "CARTICULO", "id", "ID");

        setFiltersState(prev => ({
          ...prev,
          articulo: text ?? "",
          cArticulo: val ?? ""
        }));

        break;
      }

    /*  case "proveedor": {

        const text =
          pick(item, "proveedor", "PROVEEDOR", "nombre", "NOMBRE");

        const val =
          pick(item, "cProveedor", "CPROVEEDOR", "id", "ID");

        setFiltersState(prev => ({
          ...prev,
          proveedor: text ?? "",
          cProveedor: val ?? ""
        }));

        break;
      }*/

      default:
        break;
    }

    closeFilterModal();
  };

  // =========================================================
  // DATA
  // =========================================================

  const [salesData, setSalesData] = useState([]);

  const [statsData, setStatsData] = useState([]);

  const [topProducts, setTopProducts] = useState([]);

  const [loading, setLoading] = useState(false);

  const [totals, setTotals] = useState({
    vendidos: 0,
    TotalVentas: 0,
    TotalDevoluciones: 0,
    TotalFinal: 0,
  });

  const [ajustes, setAjustes] = useState({
    recargos: 0,
    bonificaciones: 0,
    sinIdentificar: 0
  });

  // =========================================================
  // LIMPIAR FILTROS
  // =========================================================

  const clearFilters = () => {

    setFiltersState({

      fechaDesde: "",
      fechaHasta: "",

   /*   cliente: "",
      cCliente: "",*/

      sucursal: "",
      cSucursal: "",

      vendedor: "",
      cVendedor: "",

    /*  comprobante: "",
      cComprobante: "",*/

      period: "Hoy",
      periodValue: "hoy",

      rubro: "",
      cRubro: "",
      cSubRubro: "",

      articulo: "",
      cArticulo: "",

    /*  proveedor: "",
      cProveedor: ""*/
    });

    setSalesData([]);

    setStatsData([]);

    setTopProducts([]);

    setAjustes({
      recargos: 0,
      bonificaciones: 0
    });

    setTotals({
      vendidos: 0,
      TotalVentas: 0,
      TotalDevoluciones: 0,
      TotalCosto: 0,
      TotalFinal: 0,
    });
  };

  // =========================================================
  // UTILIDADES
  // =========================================================

  const formatMoney = (value) => {

    return Number(value || 0).toLocaleString("es-AR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  // =========================================================
  // PIE DATA
  // =========================================================

  const buildPieData = (data) => {

    const map = {};

    data.forEach(item => {

      const name =
        item.DESC_CORTA ||
        String(item.CARTICULO) ||
        "N/A";

      const total =
        parseFloat(item.TOTAL_VENTAS) || 0;

      const units =
        parseFloat(item.TOTAL_CANTIDAD) || 0;

      if (!map[name]) {

        map[name] = {
          total: 0,
          units: 0
        };
      }

      map[name].total += total;

      map[name].units += units;
    });

    const arr = Object.keys(map).map(k => ({
      name: k,
      value: map[k].total,
      units: map[k].units
    }));

    arr.sort((a, b) => b.value - a.value);

    return arr.slice(0, 10);
  };

  // =========================================================
  // TOP PRODUCTS
  // =========================================================

  const buildTopProducts = (data) => {

    const map = {};

    data.forEach(item => {

      const name =
        item.DESC_CORTA ||
        String(item.CARTICULO);

      if (!map[name]) {

        map[name] = {
          articulo: name,
          cantidad: 0,
          costo: 0,
          total: 0,
          margen: 0
        };
      }

      map[name].cantidad +=
        Number(item.TOTAL_CANTIDAD || 0);

      map[name].costo +=
        Number(item.TOTAL_COSTO || 0);

      map[name].total +=
        Number(item.TOTAL_VENTAS || 0);

      map[name].margen =
        map[name].total - map[name].costo;  
    });

    return Object.values(map)
      .sort((a, b) => b.cantidad - a.cantidad)
      .slice(0, 10);
  };

  // =========================================================
  // APPLY FILTERS
  // =========================================================

  const handleApplyFilters = async (e) => {

    e.preventDefault();

    setSalesData([]);

    setLoading(true);

    const filtros = {

      fechaDesde: filtersState.fechaDesde || null,
      fechaHasta: filtersState.fechaHasta || null,

     /* cCliente: filtersState.cCliente || null,*/
      cSucursal: filtersState.cSucursal || null,
      cVendedor: filtersState.cVendedor || null,
     /* cComprobante: filtersState.cComprobante || null,*/

      period: filtersState.periodValue || null,

      cRubro:
        filterMode === "rubro"
          ? filtersState.cRubro || null
          : null,

      cSubRubro:
        filterMode === "rubro"
          ? filtersState.cSubRubro || null
          : null,

      cArticulo:
        filterMode === "articulo"
          ? filtersState.cArticulo || null
          : null

    /*  cProveedor: filtersState.cProveedor || null*/
    };

    try {

      const response = await fetch(
        "api/salesArticleList.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "include",
          body: JSON.stringify(filtros)
        }
      );

      if (response.status === 401) {

        localStorage.clear();

        alert("Sesión expirada");

        navigate("/");

        return;
      }

      const text = await response.text();

      let data;

      try {

        data = JSON.parse(text);

      } catch (e) {

        console.error("Error parseando JSON:", e);

        setLoading(false);

        return;
      }

const ordered =
  Array.isArray(data)
    ? [...data]
    : [];

// ==========================================
// RECARGOS / BONIFICACIONES
// ==========================================

const recargosRows = ordered.filter(
  item => item.TIPO_REGISTRO === "RECARGO"
);

const bonificacionesRows = ordered.filter(
  item => item.TIPO_REGISTRO === "BONIFICACION"
);

// ==========================================
// ARTICULOS SIN IDENTIFICAR
// ==========================================

const articulosSinIdentificarRows = ordered.filter(
  item =>
    !item.CARTICULO &&
    item.TIPO_REGISTRO === "ARTICULO"
);

const articulosSinIdentificarImporte =
  articulosSinIdentificarRows.reduce(
    (acc, item) =>
      acc +
      (parseFloat(item.TOTAL_VENTAS) || 0) -
      (parseFloat(item.TOTAL_DEVOLUCIONES) || 0),
    0
  );

const recargosImporte = recargosRows.reduce(
  (acc, item) =>
    acc +
    (parseFloat(item.TOTAL_VENTAS) || 0) -
    (parseFloat(item.TOTAL_DEVOLUCIONES) || 0),
  0
);

const bonificacionesImporte = bonificacionesRows.reduce(
  (acc, item) =>
    acc +
    (parseFloat(item.TOTAL_VENTAS) || 0) -
    (parseFloat(item.TOTAL_DEVOLUCIONES) || 0),
  0
);

// ==========================================
// SOLO ARTICULOS REALES
// ==========================================

const articulosRows = ordered.filter(
  item =>
    item.CARTICULO &&
    item.TIPO_REGISTRO === "ARTICULO"
);

articulosRows.sort(
  (a, b) =>
    Number(b.TOTAL_CANTIDAD) -
    Number(a.TOTAL_CANTIDAD)
);

setSalesData(articulosRows);

const pie =
  buildPieData(articulosRows);

setStatsData(pie);

setTopProducts(
  buildTopProducts(articulosRows)
);

const sum = (field) =>
  ordered.reduce(
    (acc, item) =>
      acc + (parseFloat(item[field]) || 0),
    0
  );

const totalCosto = sum("TOTAL_COSTO");

setAjustes({
  recargos: recargosImporte,
  bonificaciones: bonificacionesImporte,
  sinIdentificar: articulosSinIdentificarImporte
});

setTotals({

  vendidos:
    articulosRows.reduce(
      (acc, item) =>
        acc +
        (parseFloat(item.TOTAL_CANTIDAD) || 0),
      0
    ),

  TotalVentas:
    sum("TOTAL_VENTAS"),

  TotalDevoluciones:
    sum("TOTAL_DEVOLUCIONES"),

  TotalCosto:
    totalCosto,    

  TotalFinal:
    sum("TOTAL_VENTAS") -
    sum("TOTAL_DEVOLUCIONES")
});
  // ordered.forEach(x => {
  //   console.log(
  //     x.CARTICULO,
  //     x.DESC_CORTA,
  //     x.TIPO_REGISTRO,
  //     x.TOTAL_VENTAS
  //   );
  // });

      setLoading(false);

    } catch (error) {

      console.error("Error al obtener ventas:", error);

      setLoading(false);
    }
  };

  // =========================================================
  // EXPORT EXCEL
  // =========================================================

  const exportToExcel = () => {

    if (!salesData || salesData.length === 0) {

      alert("No hay datos para exportar.");

      return;
    }

    const headers = [
      "Cod. Artículo",
      "Artículo",
      "Subrubro",
      "Proveedor",
      "Cantidad Vendida",
      "Total Costos",
      "Total Ventas",
      "Margen",
    ];


    const rows = salesData.map(row => [

      Number(row.CARTICULO),

      row.DESC_CORTA,

      row.SUBRUBRO,

      row.NOMBRE_PROVEEDOR,

      Number(row.TOTAL_CANTIDAD),

      Number(row.TOTAL_COSTO),

      Number(row.TOTAL_VENTAS),

      Number(row.TOTAL_VENTAS) - Number(row.TOTAL_COSTO),
    ]);

    const wb = XLSX.utils.book_new();

    const ws = XLSX.utils.aoa_to_sheet([
      headers,
      ...rows
    ]);

    XLSX.utils.book_append_sheet(
      wb,
      ws,
      "Ventas por Artículo"
    );

    XLSX.writeFile(
      wb,
      "Galileo-Analytics-Ventas-por-articulo.xlsx"
    );
  };

  // =========================================================
  // COLORS
  // =========================================================

  const COLORS = [
    "#10e241",
    "#ef476f",
    "#00b4d8",
    "#48cae4",
    "#051cee",
    "#fc8f00",
    "#ea04d3",
    "#121110",
    "#06d6a0",
    "#e90b0b",
    "#0077b6"
  ];

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <>

      <div className="sales-menu">

        <aside className="filters-section">

          <div className="filters-header">

            <button
              type="button"
              className="home-button"
              onClick={() => navigate("/menu")}
            >
              <img src={homeIcon} alt="Home" />
            </button>

          </div>

          <h2>Filtros</h2>

          <form
            className="sales-filters-form"
            onSubmit={handleApplyFilters}
          >

          <div className="article-filter-mode">

            <label>
              <input
                type="radio"
                name="filterMode"
                value="rubro"
                checked={filterMode === "rubro"}
                onChange={() => {
                  setFilterMode("rubro");

                  setFiltersState(prev => ({
                    ...prev,
                    articulo: "",
                    cArticulo: ""
                  }));
                }}
              />
              Rubro/Subrubro
            </label>

            <label>
              <input
                type="radio"
                name="filterMode"
                value="articulo"
                checked={filterMode === "articulo"}
                onChange={() => {
                  setFilterMode("articulo");

                  setFiltersState(prev => ({
                    ...prev,
                    rubro: "",
                    cRubro: "",
                    cSubRubro: ""
                  }));
                }}
              />
              Artículo
            </label>

          </div>

            <div className="filters-body">

              {filters
                .filter((f) => {

                  if (
                    filterMode === "rubro" &&
                    f.name === "articulo"
                  ) {
                    return false;
                  }

                  if (
                    filterMode === "articulo" &&
                    f.name === "rubro"
                  ) {
                    return false;
                  }

                  return true;
                })
                .map((f) => {

                let hiddenVal = "";

              /*  if (f.name === "cliente") {
                  hiddenVal = filtersState.cCliente || "";
                }*/
                if (f.name === "sucursal") {
                  hiddenVal = filtersState.cSucursal || "";
                }
                else if (f.name === "vendedor") {
                  hiddenVal = filtersState.cVendedor || "";
                }
            /*    else if (f.name === "comprobante") {
                  hiddenVal = filtersState.cComprobante || "";
                }*/
                else if (f.name === "rubro") {

                  hiddenVal = JSON.stringify({
                    cRubro: filtersState.cRubro || "",
                    cSubRubro: filtersState.cSubRubro || ""
                  });
                }
                else if (f.name === "articulo") {
                  hiddenVal = filtersState.cArticulo || "";
                }
               /* else if (f.name === "proveedor") {
                  hiddenVal = filtersState.cProveedor || "";
                }*/

                return (

                  <FilterField
                    key={f.name}
                    {...f}
                    value={filtersState[f.name] || ""}
                    hiddenValue={hiddenVal}
                    onChange={(e) => {

                      const value = e.target.value;

                      setFiltersState(prev => ({
                        ...prev,
                        [f.name]: value,

                        ...(f.name === "fechaDesde" || f.name === "fechaHasta"
                          ? { period: "", periodValue: "" }
                          : {})
                      }));
                    }}
                  />
                );
              })}

            </div>

            <button
              type="submit"
              className="filter-button"
            >
              Aplicar filtros
            </button>

            <button
              type="button"
              className="delete-filter-button"
              onClick={clearFilters}
            >
              Borrar filtros
            </button>

            <button
              type="button"
              className="export-excel-button"
              onClick={exportToExcel}
            >
              Exportar Datos
            </button>

          </form>

        </aside>

        <main className="sales-data">

          <div className="stats-cards">

            <div className="stat-card">
              <span>Unidades Vendidas</span>
              <h2>{formatMoney(totals.vendidos)}</h2>
            </div>

            <div className="stat-card">
              <span>Total Ventas</span>
              <h2>${formatMoney(totals.TotalVentas)}</h2>
            </div>

            <div className="stat-card">
              <span>Devoluciones</span>
              <h2>${formatMoney(totals.TotalDevoluciones)}</h2>
            </div>

          <div className="stat-card">
            <span>Recargos | Bonificaciones</span>

            <h2>
              ${formatMoney(ajustes.recargos)}
              {" | "}
              ${formatMoney(ajustes.bonificaciones)}
            </h2>
          </div>

          <div className="stat-card">
            <span>Artículos sin identificar</span>
            <h2>
              ${formatMoney(ajustes.sinIdentificar)}
            </h2>
          </div>

          <div className="stat-card">
            <span>Total Costo</span>
            <h2>${formatMoney(totals.TotalCosto)}</h2>
          </div>

            <div className="stat-card">
              <span>Total Final</span>
              <h2>${formatMoney(totals.TotalFinal)}</h2>
            </div>

          </div>

          <div className="charts-grid">

            <div className="chart-card">

              <div className="chart-title">
                Participación por Artículo
              </div>

              <div className="pie-chart-container">

                <ResponsiveContainer width="100%" height={450}>

                  <PieChart>

                      <Pie
                        data={statsData}
                        dataKey="value"
                        nameKey="name"
                        cx="50%"
                        cy="50%"
                        outerRadius={140}
                        label={false}
                      >

                      {statsData.map((entry, index) => (

                        <Cell
                          key={index}
                          fill={COLORS[index % COLORS.length]}
                        />
                      ))}

                    </Pie>

                    <ReTooltip
                      formatter={(value) =>
                        `$${formatMoney(value)}`
                      }
                    />

                    <Legend
                      verticalAlign="bottom"
                      wrapperStyle={{
                        fontSize: "11px"
                      }}
                    />

                  </PieChart>

                </ResponsiveContainer>

              </div>

            </div>

            <div className="chart-card">

              <div className="chart-title">
                Top 10 Más Vendidos
              </div>

              <div className="chart-wrapper">

                <ResponsiveContainer width="100%" height={450}>

                  <BarChart
                    data={topProducts}
                    layout="vertical"
                    margin={{
                      top: 20,
                      right: 20,
                      left: 120,
                      bottom: 10
                    }}
                  >

                    <CartesianGrid strokeDasharray="3 3" />

                    <XAxis type="number" />

                    <YAxis
                      type="category"
                      dataKey="articulo"
                      width={220}
                      tick={{ fontSize: 11 }}
                      interval={0}
                      tickFormatter={(value) =>
                        value.length > 28
                          ? value.substring(0, 28) + "..."
                          : value
                      }
                    />

                    <ReTooltip
                      formatter={(value) =>
                        formatMoney(value)
                      }
                    />

                    <Bar
                      dataKey="cantidad"
                      fill="#0077b6"
                      radius={[0, 6, 6, 0]}
                    />

                  </BarChart>

                </ResponsiveContainer>

              </div>

            </div>

          </div>

          <div className="summary-card">

            <h3>Top 10 Artículos</h3>

            <div className="top-products-table">

              <table>

                <thead>

                  <tr>
                    <th>Artículo</th>
                    <th>Unidades</th>
                    <th>Costo</th>
                    <th>Total</th>
                    <th>Margen</th>
                  </tr>

                </thead>

                <tbody>

                  {topProducts.map((item, idx) => (

                    <tr key={idx}>

                      <td>{item.articulo}</td>

                      <td>
                        {formatMoney(item.cantidad)}
                      </td>

                      <td>
                        ${formatMoney(item.costo)}
                      </td>

                      <td>
                        ${formatMoney(item.total)}
                      </td>

                      <td>
                        ${formatMoney(item.margen)}
                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          </div>

        </main>

      </div>

      <div className='sales-menu-footer'>

      <div className="footer-left-logo">

        <img
          className="footer-system-logo"
          src={`${process.env.PUBLIC_URL}/logos/galileoinsight-logo.png`}
          alt="Logo Sistema"
        />

      </div>

        <footer>
          <span>
            Sesión Actual: {userName} | {clientName}
          </span>
        </footer>

      </div>

      <GenericModal
        title={modalTitle}
        isOpen={modalOpen}
        data={modalData}
        onSelect={handleSelect}
        onClose={closeFilterModal}
      />

      <LoadingModal open={loading} />

    </>
  );
}